import { Route, Routes } from "react-router-dom";
import TeamDetail from "./TeamDetail";
import TeamsPage from "./TeamsPage";

const ObjectivePage = () => {
  return (
    <Routes>
      <Route>
        <Route index element={<TeamsPage />} />
        <Route path=":teamId" element={<TeamDetail />} />
      </Route>
    </Routes>
  );
};

export default ObjectivePage;
